import React, { useEffect, useState, } from 'react'
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import "../App.css";
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, deleteDoc, doc, updateDoc, getDocs, where } from 'firebase/firestore'
import Menu from '../panel/Menu';

export default function Companydetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [companydetails, setcompanydetails] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [companyname, setcompanyname] = useState("");
    const [gstno, setgstno] = useState("");
    const [gstname, setgstname] = useState("");

    const [updocid, setupdocid] = useState("");
    const [upcompanyname, setupcompanyname] = useState("");
    const [upgstno, setupgstno] = useState("");
    const [upgstname, setupgstname] = useState("");
    const [importLoading, setImportLoading] = useState(false);

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'companydetails'), orderBy('createdAt', 'asc'))
            onSnapshot(q, (querySnapshot) => {
                setcompanydetails(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = companydetails.filter((item) =>
                item.data.companyname.toUpperCase().includes(searchText.toUpperCase())
            );
            setcompanydetails(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    const handleSubmit = async () => {
        try {
            await addDoc(collection(db, "companydetails"), {
                companyname: companyname,
                gstname: gstname,
                gstno: gstno,
                uid: userData.uid,
                createdAt: Timestamp.now(),
            });

            setcompanyname("");
            setgstno("");
            setgstname("");
            fetchData1();

            Toast.fire({
                icon: "success",
                title: 'Company Details Added Successfully!!'
            });
        } catch (err) {
            Toast.fire({
                icon: "error",
                title: 'Error in Room Service Adding!!'
            });

            console.log(err.message);
        }
    }

    const handleDelete = async (docid, imgLink) => {
        const taskDocRef = doc(db, 'companydetails', docid)
        await deleteDoc(taskDocRef)
        Toast.fire({
            icon: "success",
            title: 'Company Details Deleted Successfully!!'
        });
        fetchData1();
    }

    const handleEdit = (id, companyname, gstname, gstno) => {
        setupdocid(id);
        setupcompanyname(companyname);
        setupgstname(gstname);
        setupgstno(gstno);
    }

    const handleUpdate = async () => {
        if (!upcompanyname) {
            Toast.fire({
                icon: "error",
                title: 'Please Enter Required Fields!!'
            });
            return;
        }

        await updateDoc(doc(db, "companydetails", updocid), {
            companyname: upcompanyname,
            gstname: upgstname,
            gstno: upgstno,
        });
        Toast.fire({
            icon: "success",
            title: 'Company Details Updated Successfully!!'
        });

        fetchData1();
    }

    const importCompaniesFromCustomers = async () => {

        try {

            setImportLoading(true);

            const customersRef = collection(db, "customers");
            const companyRef = collection(db, "companydetails");

            // 🔹 Fetch both collections in parallel
            const [customersSnap, companySnap] = await Promise.all([
                getDocs(customersRef),
                getDocs(companyRef)
            ]);

            // 🔹 Store existing GST numbers
            const existingGST = new Set();
            companySnap.docs.forEach(doc => {
                const data = doc.data();
                if (data.gstno) existingGST.add(data.gstno);
            });

            const promises = [];

            // 🔹 Loop customers
            customersSnap.docs.forEach(docSnap => {

                const customer = docSnap.data().customerData;

                if (!customer?.gstno || !customer?.gstname) return;

                const gstname = customer.gstname.trim();
                const gstno = customer.gstno.trim();

                if (!existingGST.has(gstno)) {

                    existingGST.add(gstno);

                    promises.push(
                        addDoc(companyRef, {
                            companyname: gstname,
                            gstname: gstname,
                            gstno: gstno,
                            uid: userData.uid,
                            createdAt: Timestamp.now()
                        })
                    );
                }

            });

            await Promise.all(promises);

            Toast.fire({
                icon: "success",
                title: "Companies Imported Successfully"
            });

        } catch (error) {
            console.log(error);
        }

        setImportLoading(false);
    };
    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| Company Details  Mgmt ||</button>
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={importCompaniesFromCustomers}
                            disabled={importLoading}
                        >
                            {importLoading ? "Importing..." : "Import From Customers"}
                        </button>&nbsp;&nbsp;
                        <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">Add Company Details</button><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Company Details </th>
                                            <th>GST Name</th>
                                            <th>GST No</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            companydetails.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.data.companyname}</td>
                                                    <td>{item.data.gstname}</td>
                                                    <td>{item.data.gstno}</td>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.data.companyname, item.data.gstname, item.data.gstno)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id, item.data.imageurl) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}

            <div className="modal fade" id="insert-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Company Details</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>  Company Details </label>
                                    <input type="text" value={companyname} onChange={(e) => setcompanyname(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6">
                                    <label>  GST Name </label>
                                    <input type="text" value={gstname} onChange={(e) => setgstname(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6">
                                    <label>  GST No </label>
                                    <input type="text" value={gstno} onChange={(e) => setgstno(e.target.value)} className="form-control" />
                                </div>
                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleSubmit()} className="btn btn-primary" data-dismiss="modal">Save </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Company Details</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>  Company Details </label>
                                    <input type="text" value={upcompanyname} onChange={(e) => setupcompanyname(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 ">
                                    <label>GST Name</label>
                                    <input type="text" value={upgstname} onChange={(e) => setupgstname(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 ">
                                    <label>GST No</label>
                                    <input type="text" value={upgstno} onChange={(e) => setupgstno(e.target.value)} className="form-control" />
                                </div>
                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
